<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BookWithDuplicates } from '@ilteducation/books';
import { useLocale } from '@/plugins/translation';
import { computed } from 'vue';
import { useConfigHelper } from '@ilteducation/config';

const props = withDefaults(
  defineProps<{
    book: BookWithDuplicates;
    maxWidth?: number;
  }>(),
  {
    maxWidth: 200,
  },
);

const { getAppUrl } = useConfigHelper();

const playBookLink = computed(
  () => `${getAppUrl('inlasta', 'ilteducation.se')}/books/${props.book.id}/read?reauthenticate=auto`,
);
const { t, l } = useLocale();
</script>

<template>
  <v-btn
    style="z-index: 10"
    target="_blank"
    :href="playBookLink"
    :size="maxWidth / 3"
    class="play-button elevation-1 bg-white rounded-circle"
    :aria-label="t(l.library.button_play)"
  >
    <FontAwesomeIcon icon="fa-solid fa-play" size="lg" />
  </v-btn>
</template>

<style scoped lang="scss">
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  border-radius: 50%;
}
</style>
